import { graphql } from "gatsby"
import React, { useContext } from "react"
import { useTranslation } from "react-i18next"

import { SiteContext } from "@context/Provider"
import Breadcrumb from "@knowit-alma/common/src/components/molecules/Breadcrumb/Breadcrumb"

const BreadcrumbBlock = ({ wide, tight }) => {
  const { t } = useTranslation()

  const context = useContext(SiteContext)
  const currentLanguage =
    context && context.currentLanguage ? context.currentLanguage : "fi"

  const homeSlug = currentLanguage === "fi" ? "/" : "/" + currentLanguage + "/"

  let ancestors = context?.ancestors
    ? context.ancestors.nodes.map((item) => {
        return {
          title: item.title,
          url: item.uri,
        }
      })
    : null

  ancestors = ancestors ? ancestors : []

  return (
    <section
      className={`block-breadcrumb ${
        tight ? "base-margin-top-xs" : "base-margin-top"
      } base-margin-bottom-xxs text-align-left`}
    >
      <div className={wide ? "" : "max-vvw"}>
        <Breadcrumb
          ancestors={[
            {
              title: t("Home"),
              url: homeSlug,
            },
            ...ancestors.reverse(),
          ]}
          current={context.title}
        />
      </div>
    </section>
  )
}

export const query = graphql`
  fragment Breadcrumb on WpBlockAcfBreadcrumb {
    __typename
  }
`

export default BreadcrumbBlock
